import { render, staticRenderFns } from "./GLS.vue?vue&type=template&id=32d18026&scoped=true&"
import script from "./GLS.vue?vue&type=script&lang=js&"
export * from "./GLS.vue?vue&type=script&lang=js&"
import style0 from "./GLS.vue?vue&type=style&index=0&id=32d18026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d18026",
  null
  
)

export default component.exports